import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { ResourceEditAddFieldButtonComponent } from '®app/resource/edit/add-fields/add-field-button/resource-edit-add-field-button.component';
import { ResourceEditAddFieldsComponent } from '®app/resource/edit/add-fields/resource-edit-add-fields.component';

@NgModule({
  imports: [CommonModule, BsDropdownModule],
  declarations: [
    ResourceEditAddFieldButtonComponent,
    ResourceEditAddFieldsComponent,
  ],
  exports: [
    ResourceEditAddFieldButtonComponent,
    ResourceEditAddFieldsComponent,
  ],
})
export class ResourceEditAddFieldsModule {}
